import React from 'react';
import { motion } from 'framer-motion';
import { Play, ArrowRight } from 'lucide-react';
import { scrollToOffer } from '../utils/scrollToOffer';
export function HeroSection() {
  return <section className="relative min-h-[95vh] flex flex-col items-center justify-center px-6 py-28 md:py-40 bg-black text-white overflow-hidden pt-[10px] pb-[10px]" data-id="element-32">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05)_0%,transparent_100%)] pointer-events-none" data-id="element-33" />

      <div className="w-full max-w-4xl mx-auto flex flex-col items-center text-center z-10" data-id="element-34">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tight leading-[1.1] mb-12" data-id="element-35">
          Antes el tráfico pasaba por la calle.{' '}
          <br className="hidden md:block" data-id="element-36" />
          <span className="text-gray-400" data-id="element-37">Hoy pasa por el celular.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="md:text-3xl max-w-3xl mb-8 text-[30px] font-[600] text-[#BDC0C5]" data-id="element-38">
          Si hoy no generas alcance, no vas a generar mas clientes.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-500 font-medium mb-16" data-id="element-39"></motion.p>

        <div className="w-full max-w-4xl mx-auto mb-16" data-id="element-40">
  <div style={{
          padding: "75% 0 0 0",
          position: "relative"
        }} data-id="element-41">
    <iframe src="https://player.vimeo.com/video/1180337674?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
          }} title="vsl lucas" data-id="element-42" />
  </div>
  <script src="https://player.vimeo.com/api/player.js" data-id="element-43"></script>
</div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col items-center w-full max-w-md" data-id="element-44">
          <button onClick={scrollToOffer} className="w-full bg-white text-black font-black text-xl h-16 md:h-20 rounded-2xl flex items-center justify-center gap-3 hover:bg-gray-200 transition-colors active:scale-[0.98] shadow-xl" data-id="element-45">
            Quiero más clientes <ArrowRight className="w-6 h-6" data-id="element-46" />
          </button>
          <p className="mt-6 text-sm md:text-base text-gray-500 font-medium flex items-center gap-3" data-id="element-47">
            Acceso inmediato{' '}
            <span className="w-1.5 h-1.5 bg-gray-500 rounded-full" data-id="element-48" /> Pago único
          </p>
        </motion.div>
      </div>
    </section>;
}